import React, { Fragment } from "react";
import { Alerts, P } from "../../../../AbstractElements";
import { Col } from "reactstrap";
import { DARK_THEME_LIST } from "../../../../Data/UiKit/Alert";
import { Href } from "../../../../Constant";

export const DarkThemeLeftSection = () => {
  return (
    <Col xl="6">
      <P className="mb-0 ">Primary Alert</P>
      <Alerts color="primary" className="dark">
        <P>{`This is a `}<a className="alert-link text-white " href={Href}>primary alert</a>{` with an example link.Check it out.`}</P>
      </Alerts>
      {DARK_THEME_LIST.map(({ title, color }, index) => (
        <Fragment key={index}>
          <P className="mb-0">{title}</P>
          <Alerts color={color} className="dark">
            <P>{`This is a `}<a className="alert-link text-white text-lowercase" href={Href}>{title}</a>{` with an example link.Check it out.`}</P>
          </Alerts>
        </Fragment>
      ))}
    </Col>
  );
};
